import React from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';

import TableData from '../../../../components/Table/TableData';
import UserCardSmall from '../../../../components/UserCardSmall/UserCardSmall';
import TableRow from '../../../../components/Table/TableRow';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import ButtonDropdownList from '../../../../components/ButtonDropdownList/ButtonDropdownList';
import Badge from '../../../../components/Badge/Badge';
import ButtonTypes from '../../../../constants/buttonTypes';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../../common/permissionGroup';
import accountStatus from '../../../../constants/accountStatus';

const userColumnClassName = 'capitalize';

const UserRow = ({ user, bordered, actionList }) => {
  return (
    <TableRow key={user?.id} bordered={bordered}>
      <TableData>
        <Checkbox name={`check_${user?.id}`} />
      </TableData>
      <TableData>
        <UserCardSmall user={user} />
      </TableData>
      <TableData className={userColumnClassName}>
        {user?.role?.name}
      </TableData>
      <TableData>
        <Badge
          text={user?.account_status}
          type={user?.account_status === accountStatus.ACTIVE ? ButtonTypes.SUCCESS : ButtonTypes.DANGER}
        />
      </TableData>
      <TableData>
        <Badge
          text={user?.two_factor_enabled ? 'enabled' : 'disabled'}
          type={user?.two_factor_enabled ? ButtonTypes.INFO : ButtonTypes.WARNING}
        />
      </TableData>
      <TableData>
        <Badge
          type={ButtonTypes.LIGHT}
          text={user?.last_login && DateTime.fromISO(user?.last_login).setLocale('en').toRelative()}
        />
      </TableData>
      <TableData>
        {DateTime.fromISO(user?.created_at).setLocale('en').toFormat('DD')}
      </TableData>
      <PermissionsGate can={permissions.USERS_UPDATE}>
        <TableData>
          <div className="flex flex-row justify-end">
            <ButtonDropdownList actionList={actionList} item={user} label="Action" />
          </div>
        </TableData>
      </PermissionsGate>
    </TableRow>
  );
};

UserRow.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    login: PropTypes.string,
    created_at: PropTypes.string,
    last_login: PropTypes.string,
    account_status: PropTypes.string,
    two_factor_enabled: PropTypes.bool,
    role: PropTypes.shape({
      name: PropTypes.string
    }),
  }),
  bordered: PropTypes.bool,
  actionList: PropTypes.arrayOf(PropTypes.shape({}))
};

UserRow.defaultProps = {
  user: {},
  bordered: true,
  actionList: []
};

export default UserRow;
